import { Reveal } from "@/components/Reveal";

const STEPS = [
  { week: "Week 0", title: "Composition", text: "Raw materials weighed and blended by hand into concentrated oil." },
  { week: "Weeks 1–4", title: "Maceration", text: "The blend rests in darkness as molecules bind and sharp edges soften." },
  { week: "Weeks 5–8", title: "Maturation", text: "Cold-matured to deepen base notes and stabilise the full accord." },
  { week: "Weeks 8–10", title: "Rest & Bottle", text: "Filtered, rested and bottled only when the signature is seamless." },
];

export default function MaturationSection() {
  return (
    <section data-testid="maturation-section" className="bg-[#EFE9E1]">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-24 md:py-32">
        <Reveal className="max-w-2xl">
          <p className="overline-label">Patience</p>
          <h2 className="font-serif-brand text-4xl md:text-5xl font-light mt-4 leading-tight">
            The 8–10 Week Maturation
          </h2>
          <p className="mt-6 text-sm md:text-base text-black/60 leading-relaxed">
            Most fragrances ship within days of blending. Ours wait. Ten weeks of controlled rest is the difference between a scent and a signature.
          </p>
        </Reveal>
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-black/10 border border-black/10">
          {STEPS.map((s, i) => (
            <Reveal key={s.week} delay={i * 0.1} className="bg-[#EFE9E1] p-8 md:p-10">
              <p className="overline-label">{s.week}</p>
              <h3 className="font-serif-brand text-2xl font-light mt-4">{s.title}</h3>
              <p className="mt-3 text-sm text-black/55 leading-relaxed">{s.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
